import { compareItemLimit, compareURL } from '../../configuration/Configuration.js';
import iconChevronUp from '@fnacdarty/fnac-icons/svg/chevron-up.svg?svgref';
import iconClose from '@fnacdarty/fnac-icons/svg/close.svg?svgref';
import iconHTML from '../../helpers/html/icon.js';
import iconInfo from '@fnacdarty/fnac-icons/svg/info.svg?svgref';
import iconPlaceholder from '@fnacdarty/fnac-icons/svg/icon_i_283_placeholder.svg?svgref';
import translation from '../../helpers/translation/translation.js';

/**
 * Generates the main banner template
 *
 * @returns {string} HTML template for the compare banner
 */
export const renderBanner = () => `
  <form class="f-compare-banner f-compare-banner--closed" target="_blank" action="${compareURL}" data-automation-id="comparator-block" data-component-id="CompareBanner" data-track-submit="compare">
    <button class="f-compare-banner__button js-compareBannerBtn" type="button" aria-expanded="false" data-automation-id="comparator-banner-button">
      <span class="f-compare-banner__label f-compare-banner__label--show" data-automation-id="open-comparator-title-label">${translation('nav.core.compare.banner.show')}</span>
      <span class="f-compare-banner__label f-compare-banner__label--hide" data-automation-id="close-comparator-title-label">${translation('nav.core.compare.banner.hide')}</span>
      &nbsp;
      <span class="f-compare-banner__count"></span>
      ${iconHTML(iconChevronUp, { className: 'f-compare-banner__icon' })}
    </button>

    <div class="f-compare-banner__content">
      <div class="f-compare-banner__wrapper">
        <ul class="f-compare-banner__items"></ul>

        <div class="f-compare-banner__actions">
          <button class="f-compare-banner__action f-compare-banner__action--disabled js-goToCompare">${translation('nav.core.compare.action.start')}</button>
          <button class="f-compare-banner__action f-compare-banner__action--alt js-compareBannerClear" type="reset">${translation('nav.core.compare.action.end')}</button>
        </div>
      </div>
    </div>
  </form>`;

/**
 * Generates the error message template
 *
 * @param {string} errorName The name of the error
 * @returns {string} HTML template for the error message
 */
export const renderErrorTemplate = (errorName) => {
  let itemRow = '';
  let message = '';
  switch (errorName) {
    case 'ItemLimitError':
      itemRow = compareItemLimit + 1;
      message = translation('nav.core.compare.maxarticlereached', itemRow, compareItemLimit);
      break;
    case 'InvalidItemTypeError':
      message = translation('nav.core.compare.badarticletype');
      break;
    default:
      message = translation('core.common.htmlfooter.flashmessage-title');
      break;
  }

  return `
  <div class="f-compare-error">
    ${iconHTML(iconInfo, { className: 'f-compare-error__icon' })}
    <p class="f-compare-error__message">${message}</p>
  </div>`;
};

/**
 * Generates a placeholder item template
 *
 * @returns {string} HTML template for an empty item placeholder
 */
export const renderItemPlaceholder = () => `
  <li class="f-compare-item f-compare-item--empty" aria-hidden="true">
    ${iconHTML(iconPlaceholder, { className: 'f-compare-item__placeholder' })}
  </li>
`;

/**
 * Generates a compare item template
 *
 * @param {object} item The item data
 * @returns {string} HTML template for a compare item
 */
export const renderItem = (item) => {
  const itemContent = item.Inactive
    ? `<span class="f-compare-item__link">
        <img class="f-compare-item__image" src="${item.imageSrc}" alt="${item.name}" width="47" height="47">
        <span class="f-compare-item__name">${item.name}</span>
      </span>`
    : `<a class="f-compare-item__link" href="${item.link}">
        <img class="f-compare-item__image" src="${item.imageSrc}" alt="${item.name}" width="47" height="47">
        <span class="f-compare-item__name">${item.name}</span>
        <span class="f-compare-item__rating f-star f-star--small S${item.averageRating}">${item.averageRating}</span>
      </a>`;

  return `<li class="f-compare-item">
    <input type="hidden" name="products" value="${item.catalog}-${item.prid}">
    ${itemContent}
    <button class="f-compare-item__close js-removeCompareItem" type="button" data-prid="${item.prid}" data-catalog="${item.catalog}">
      ${iconHTML(iconClose, { className: 'icon_tag' })}
    </button>
  </li>`;
};
